import baseStyles from './global';

export default baseStyles;
